import type { Context } from '@nuxt/types';
import { COOKIE_NAME_SAVED_JOB_TITLE } from '@/components/common/constants';

/**
 * Job title could be asked on /login-external page before login
 * Here we save it to user profile after signup
 */
export default function setJobTitleAfterSignUp(ctx: Context) {
  const { $auth, $cookies, store } = ctx;
  const savedJobTitle = $cookies?.get(COOKIE_NAME_SAVED_JOB_TITLE);

  if ($auth.loggedIn && savedJobTitle) {
    store.dispatch('warRoom/updateOnboardingProfile', { war_room_position: savedJobTitle });
    $cookies?.remove(COOKIE_NAME_SAVED_JOB_TITLE);
  }
}
